import React from "react";
import SectionContentBox from "../SectionContentBox";
import {ContactUsImg} from "../../assets/icons";
import ContactUsForm from "./contactUsForm/ContactUsForm";
import {useLanguage} from "../../hooks/LanguageContext"; // Assuming you have a language context

const ContactUs = () => {
	const { direction, language } = useLanguage(); // Get language direction (ltr/rtl) and language

	return (
		<section className={`container ${direction === "rtl" ? "text-right" : "text-left"}`}>
			<SectionContentBox
				justify="justify-center"
				className="mt-8"
				width="w-full mx-auto"
				align="items-center"
				title={language === "ar" ? "تواصل معنا" : "Contact Us"}
				hasTowLines={true}
				headline={
					<>
						{language === "ar" ? (
							<>
								نحن هنا <span className="text-primary-700"> لمساعدتك </span> في
								اى وقت
							</>
						) : (
							<>
								We are here <span className="text-primary-700"> to help </span> you at
								any time
							</>
						)}
					</>
				}
				paragraph={
					language === "ar"
						? "نحن هنا للإجابة على جميع استفساراتك وتقديم الدعم الذي تحتاجه. يرجى ملء النموذج وسيتواصل معك فريقنا في أقرب وقت."
						: "We are here to answer all your inquiries and provide the support you need. Please fill out the form, and our team will contact you shortly."
				}
				hideBtn={true}
			/>
			<div className={`flex flex-col-reverse ${direction === "rtl" ? "md:flex-row-reverse" : "md:flex-row"} items-center md:gap-[25px] gap-5 mt-16`}>

				<div className="md:w-1/2 w-full md:h-[696.69px] h-auto flex  items-center justify-center">

					<ContactUsImg className="w-full" />
				</div>
				<div className={`md:w-1/2 w-full flex flex-col items-center gap-[10px] rounded-[30px] ${direction === "rtl" ? "order-first" : ""}`}>
					<ContactUsForm />
				</div>
			</div>
		</section>
	);
};

export default ContactUs;
